import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import ReactGA from 'react-ga';
import Main from './components/Main';
import registerServiceWorker from './registerServiceWorker';

TagManager.initialize({ gtmId: 'GTM-TGSRNWV' });

/**
 * Initialize Google Analytics Tracker
 */
const isProduction = process.env.NODE_ENV === 'production';
const gaTrackingID = isProduction ? process.env.REACT_APP_GA_TRACKING_ID : 'UA-138344259-2';
ReactGA.initialize(gaTrackingID, { debug: !isProduction });

ReactDOM.render(<Main />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js